(() => {
  const testClass = 'MC_COLLECTION_SWIPABLEIMAGES_ICON';
  const tag = 'mc-collection-images';
  if (customElements.get(tag)) return;

  class CollectionImages extends HTMLElement {
    connectedCallback() {
      this.sync();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    sync() {
      this.active = document.body.classList.contains(testClass);
      if (!this.active) {
        if (this.track) this.goTo(0, false);
        return;
      }
      if (!this.track) this.initialize();
      this.resizeObserver?.observe(this);
    }

    initialize() {
      const template = this.querySelector('template');
      const original = this.querySelector('a');
      if (!template || !original) return;

      this.track = document.createElement('div');
      this.track.className = 'mc-collection-images__track';
      this.track.append(original, template.content.cloneNode(true));
      this.prepend(this.track);
      this.slides = Array.from(this.track.children);
      this.dots = document.createElement('div');
      this.dots.className = 'mc-collection-images__dots';
      this.slides.forEach((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `${index + 1} / ${this.slides.length}`);
        button.addEventListener('click', () => this.goTo(index));
        this.dots.append(button);
      });
      if (this.slides.length > 1) this.append(this.dots);
      this.index = 0;
      this.update();

      this.track.addEventListener('scroll', () => {
        if (!this.active) return;
        const width = this.track.clientWidth;
        this.index = width ? Math.round(Math.abs(this.track.scrollLeft) / width) : 0;
        this.update();
      }, { passive: true });
      this.addEventListener('keydown', event => {
        if (!this.active || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const rtl = getComputedStyle(this).direction === 'rtl';
        let index = this.index + ((event.key === 'ArrowRight') !== rtl ? 1 : -1);
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = this.slides.length - 1;
        this.goTo(index);
      });
      this.track.addEventListener('dragstart', event => {
        if (this.active) event.preventDefault();
      });
      this.track.addEventListener('pointerdown', event => {
        if (!this.active || !event.isPrimary || event.button !== 0) return;
        this.suppressClick = false;
        this.gesture = { x: event.clientX, y: event.clientY, scroll: this.track.scrollLeft, id: event.pointerId, mouse: event.pointerType === 'mouse' };
      });
      this.track.addEventListener('pointermove', event => {
        const gesture = this.gesture;
        if (!this.active || !gesture) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
          this.suppressClick = true;
          if (gesture.mouse) {
            this.track.setPointerCapture(gesture.id);
            this.track.classList.add('is-dragging');
            this.track.scrollLeft = gesture.scroll - dx;
          }
        }
      });
      const endGesture = () => {
        if (!this.gesture) return;
        const mouse = this.gesture.mouse;
        this.gesture = null;
        this.track.classList.remove('is-dragging');
        if (mouse && this.active) this.goTo(Math.round(Math.abs(this.track.scrollLeft) / this.track.clientWidth));
      };
      this.track.addEventListener('pointerup', endGesture);
      this.track.addEventListener('pointercancel', endGesture);
      this.track.addEventListener('lostpointercapture', endGesture);
      this.track.addEventListener('click', event => {
        if (this.active && this.suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          this.suppressClick = false;
        }
      }, true);
      this.resizeObserver = new ResizeObserver(() => {
        const bundleBar = this.parentElement.querySelector('.kop-bundle-bar');
        this.style.setProperty('--mc-bundle-height', `${bundleBar?.offsetHeight || 0}px`);
        if (this.active) this.goTo(this.index, false);
      });
      const bundleBar = this.parentElement.querySelector('.kop-bundle-bar');
      if (bundleBar) this.resizeObserver.observe(bundleBar);
    }

    goTo(index, smooth = true) {
      this.index = Math.max(0, Math.min(this.slides.length - 1, index));
      const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
      this.track.scrollTo({
        left: direction * this.index * this.track.clientWidth,
        behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'
      });
      this.update();
    }

    update() {
      Array.from(this.dots.children).forEach((button, index) => {
        button.setAttribute('aria-current', String(index === this.index));
      });
      this.slides.forEach((slide, index) => {
        slide.tabIndex = index === this.index ? 0 : -1;
      });
    }
  }

  customElements.define(tag, CollectionImages);
  new MutationObserver(() => {
    document.querySelectorAll(tag).forEach(gallery => gallery.sync());
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
